import React from 'react';
import PropTypes from 'prop-types';

class DecimalInput extends React.Component {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputRef: PropTypes.func,
    onChange: PropTypes.func,
    delimiters: PropTypes.string,
  };
  static defaultProps = {
    value: undefined,
    inputRef: undefined,
    onChange: () => {},
    delimiters: '.,',
  };

  state = {
    tempValue: this.props.value,
    isInDotMode: false,
  };

  componentDidUpdate() {
    const { value } = this.props;
    const { isInDotMode, tempValue } = this.state;

    if (!isInDotMode && `${tempValue}` !== `${value}`) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ tempValue: value ? `${value}` : value });
    }
  }

  handleChange = e => {
    let { value } = e.target;
    const { onChange, delimiters } = this.props;

    value = value.replace(new RegExp(`[${delimiters}]`, 'g'), '.');

    if (value && value.startsWith('.')) {
      value = '';
    }

    if (value === '' || value.match(/^\d+(\.\d+)?$/)) {
      this.setState({ isInDotMode: false });
      onChange(value);
    } else if (value.match(/^\d+\.$/)) {
      this.setState({
        tempValue: value,
        isInDotMode: true,
      });
    }
  };

  handleBlur = () => {
    if (this.state.isInDotMode) {
      this.setState(({ tempValue }) => {
        const newValue = `${parseInt(tempValue, 10)}`;
        this.props.onChange(newValue);
        return { tempValue: newValue };
      });
    }
  };

  render() {
    const { inputRef, ...props } = this.props;
    return (
      <input
        {...props}
        type="tel"
        ref={inputRef}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        value={this.state.tempValue || ''}
      />
    );
  }
}

export default DecimalInput;



// WEBPACK FOOTER //
// ./src/shared/components/DecimalInput/DecimalInput.js